import { useTranslate } from '../i18n'

/* Маппинг локалей проекта на BCP-47 теги для Intl.PluralRules */
const PLURAL_LOCALES: Record<string, string> = {
  rs: 'sr',
  kz: 'kk',
}

/**
 * Функция выбора индекса плюральной формы по правилам локали.
 * Строка перевода хранит формы через « | »: нулевая, единственная и далее.
 * @param count
 * @param locale
 * @param formsCount
 */
const selectFormIndex = (count: number, locale: string, formsCount: number): number => {
  const category = new Intl.PluralRules(PLURAL_LOCALES[locale] ?? locale).select(count)
  if (formsCount === 4) {
    if (category === 'zero') return 0
    if (category === 'one') return 1
    if (category === 'few') return 2
    return 3
  }
  if (count === 0 || category === 'zero') return 0
  return category === 'one' ? 1 : formsCount - 1
}

/**
 * Функция форматирования плюральной строки перевода с подстановкой числа.
 * i18n-js не поддерживает pipe-плюрализацию, поэтому форму выбираем сами.
 * @param key
 * @param count
 */
export const pluralizeCount = (key: string, count: number): string => {
  const { trs, getLocale } = useTranslate()
  const forms = trs(key).split(' | ')
  const form = forms[selectFormIndex(count, getLocale(), forms.length)] ?? forms[forms.length - 1]
  return form.replace('{n}', String(count))
}
